/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme =>({
    check:{
            '& .griditem': {
                marginRight: pxToEm(30),
                // marginTop: pxToEm(20),
                width: '100%',
                maxWidth: pxToEm(469),
                '& .field':{
                    marginRight: pxToEm(30),
                    marginTop: pxToEm(20),
                    width: '100%',
                    maxWidth: pxToEm(469),
                    '&.name-payment-type':{
                        width: '100%',
                        maxWidth: pxToEm(310)
                    },
                    '&.name-pay-to':{
                        width: '100%',
                        maxWidth: pxToEm(638)
                    },
                    '&.name-payment-address':{
                        width: '100%',
                        maxWidth: pxToEm(961)
                    },
                }
            },
        '& .default-address':{
            maxWidth: pxToEm(961),
            width: '100%',
            height: pxToEm(48),
            border: `${pxToEm(2)} solid ${theme.color.neutral.light.swatch}`,
            borderRadius: pxToEm(4),
            marginTop: pxToEm(20),
            fontSize: pxToEm(16),
            display: 'flex',
            alignItems: 'center',
            '& .toggle':{
                margin: pxToEm(18),
                '& .checkbox':{
                    background: theme.color.supporting.light.swatch,
                    border: `${theme.color.neutral.dark.swatch} ${pxToEm(1)} solid`,
                    '& .icon':{
                        color: theme.color.supporting.light.contrast
                    }
                }
            }
        },
        // using field checkbox instead of this (make sure we use elements as they are intended)
        // '& .default-address':{
        //     maxWidth: pxToEm(961),
        //     width: '100%',
        //     height: pxToEm(48),
        //     border: `${pxToEm(2)} solid ${theme.color.neutral.light.swatch}`,
        //     borderRadius: pxToEm(4),
        //     marginTop: pxToEm(20),
        //     fontSize: pxToEm(16),
        //     display: 'flex',
        //     alignItems: 'center',
        //     '& .toggle':{
        //         margin: pxToEm(18),
        //         '& .checkbox':{
        //             background: theme.color.supporting.light.swatch,
        //             border: `${theme.color.neutral.dark.swatch} ${pxToEm(1)} solid`,
        //             '& .icon':{
        //                 color: theme.color.supporting.light.contrast
        //             }
        //         }
        //     }
        // }
    }
})